import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const onboardingState = (state: RootState) => state.scene.onboarding;

export const getGuidesStatus = createSelector(onboardingState, ({ guidesStatus }) => guidesStatus);
export const isLoading = createSelector(onboardingState, ({ loading }) => loading);
export const getGuides = createSelector(onboardingState, ({ guides }) => guides);
